import { render, staticRenderFns } from "./UploadNewBtn.vue?vue&type=template&id=9aaf0e4a&"
import script from "./UploadNewBtn.vue?vue&type=script&lang=js&"
export * from "./UploadNewBtn.vue?vue&type=script&lang=js&"
import style0 from "./UploadNewBtn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports